module.exports = __webpack_public_path__ + "img/nature-47.e5d7dc18.jpg";